import { useQuery, UseQueryResult } from '@tanstack/react-query';
import axios from 'lib/axios';

export const useUsers = (queryParams = {}): UseQueryResult<any[]> => {
	return useQuery({
		queryKey: ['users', queryParams],
		queryFn: async() => {
			const { data: { users } } = await axios.get('/users', {
				params: queryParams
			})
			return users;
		}
	});
};


